import { css } from "styled-components";

// Theme
export const LayoutTheme = {
  name: "Layout",
  PageContainer: css`
    display: flex;
    flex: 1 0 auto;
    flex-direction: column;
  `,
  Page: css`
    padding-top: ${({ theme }) => theme.page?.paddingY || "0px"};

    display: flex;
    flex: 1 0 auto;
    flex-direction: column;
  `,
};
